import { ArrowUpRight, Handshake, ShieldCheck, Zap } from "lucide-react";
import { Reveal } from "./primitives";
import { APP_LINKS } from "../../lib/site";

const POINTS = [
  { icon: ShieldCheck, label: "One standard" },
  { icon: Zap, label: "Digital workflow" },
  { icon: Handshake, label: "Local execution" },
];

export const PartnerCTA = () => (
  <section className="relative overflow-hidden bg-cream py-20 sm:py-24" data-testid="partner-cta-section">
    <div className="mx-auto max-w-[1200px] px-5 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-navy/10 bg-white p-7 shadow-2xl shadow-navy/8 sm:p-9 lg:grid lg:grid-cols-[1fr_auto] lg:items-center lg:gap-10">
          <div className="pointer-events-none absolute -right-20 -top-24 h-64 w-64 rounded-full bg-amber/15 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-teal/10 blur-3xl" />

          <div className="relative">
            <p className="eyebrow mb-4 text-amber">Partner with us</p>
            <h2 className="display-serif text-4xl leading-tight tracking-[-0.03em] text-navy sm:text-5xl">
              Become a SunShell One Partner.
            </h2>
          </div>

          <div className="relative mt-8 flex flex-col gap-5 lg:mt-0 lg:items-end">
            <div className="flex flex-wrap gap-3">
              {POINTS.map((point) => (
                <span key={point.label} className="inline-flex items-center gap-2 rounded-full border border-navy/10 bg-cream px-4 py-2 text-sm font-semibold text-navy/70">
                  <point.icon size={16} className="text-amber" />
                  {point.label}
                </span>
              ))}
            </div>
            <a
              href={APP_LINKS.partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-navy-800"
            >
              Download partner app <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
